import { render, staticRenderFns } from "./acct.vue?vue&type=template&id=1319616a"
import script from "./acct.vue?vue&type=script&lang=js"
export * from "./acct.vue?vue&type=script&lang=js"
import style0 from "./acct.vue?vue&type=style&index=0&id=1319616a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports